import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';
import { LuCalendarRange, LuFileText, LuListChecks } from 'react-icons/lu';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { SelectButton } from 'primereact/selectbutton';

import api from '../../services/api';
import useResponsaveis from '../../hooks/useResponsaveis';

import { useToast } from '../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterStyles,
  Section,
} from '../../components/FilterKit';

interface SearchData {
  inCharge: string;
  topic: string;
  description: string;
  proc_tipo: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

const SearchSchedule:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const initialValues: SearchData = {
    inCharge: 'global|0',
    topic: '',
    description: '',
    proc_tipo: 'todos',
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
  };

  const [typeId, setTypeId] = useState(0);
  const [priorityId, setPriorityId] = useState(0);
  const [scheduleStatusId, setScheduleStatusId] = useState(0);

  const [topic, setTopic] = useState('');
  const [description, setDescription] = useState('');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);

  let loggedUserLevel = '';
  let loggedUserId = 0;
  // const accessData = sessionStorage.getItem('@Jurisnet:access');
  const accessData = localStorage.getItem('@Jurisnet:access');

  if (typeof accessData === 'string') {
    const access = JSON.parse(accessData);
    loggedUserLevel = access.nivelusuario;
    loggedUserId = Number(access.usuario_logado);
  }

  let userTypeDefinition = '';
  switch (loggedUserLevel) {
    case 'Administrador':
      userTypeDefinition = 'global|0';
      break;
    case 'Advogado':
      userTypeDefinition = `adv|${loggedUserId}`;
      break;
    case 'Assistente':
      userTypeDefinition = `adm|${loggedUserId}`;
      break;
    default:
      userTypeDefinition = 'global|0';
      break;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [inCharge, setInCharge] = useState<any>(userTypeDefinition);
  const [dateFilterType, setDateFilterType] = useState('data');

  const handleClear = (resetForm: () => void) => {
    setInCharge(userTypeDefinition);
    setTopic('');
    setDescription('');
    setTypeId(0);
    setPriorityId(0);
    setScheduleStatusId(0);
    setDateFilterType('data');
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    resetForm();
  };

  const validationSchema = null;

  const optionsScheduleStatus = [
    { name: 'Todos', value: 0 },
    { name: 'A iniciar', value: 1 },
    { name: 'Em andamento', value: 2 },
    { name: 'Em espera', value: 4 },
    { name: 'Concluída', value: 3 },
  ];

  const optionsPriority = [
    { name: 'Todas', value: 0 },
    { name: 'Alta', value: 1 },
    { name: 'Normal', value: 2 },
    { name: 'Baixa', value: 3 },
  ];

  const optionsScheduleType = [
    { name: 'Todas', value: 0 },
    { name: 'Atividade', value: 1 },
    { name: 'Reunião', value: 2 },
  ];

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api.get('/management/attorneys/show/inchargelawsuits/attorneys').then((response) => {
        if (response.data.length > 0) {
          sectorOptions.push({
            name: 'Todos',
            value: 'all',
          });
          response.data.map((sector: {
            setor_adv: string
          }) => (
            sectorOptions.push({
              name: sector.setor_adv,
              value: sector.setor_adv,
            })
          ));
        }
      });

      await api.get('/management/attorneys/show/inchargelawsuits/others').then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((sector: {
            setor_adm: string
          }) => {
            if (sectorOptions.indexOf(sector.setor_adm) === -1) {
              sectorOptions.push({
                name: sector.setor_adm,
                value: sector.setor_adm,
              });
            }
          });
        }
      });

      sectorOptions.splice(0, 1);
      setSectorOptions(sectorOptions);
    })();
  }, [sectorOptions]);

    const { inChargeOptions } = useResponsaveis({
    urlAdvogados: `management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem('categoria')}/${sessionStorage.getItem('setor')}`,
    urlAssistentes: 'management/assistants/show/all/active',
    todos: {
        label: 'Todos',
        items: [
          { label: 'Todos', value: 'global|0' },
          { label: 'Todos - exceto estagiários', value: 'global|99997' },
          { label: 'Todos - exceto assistentes', value: 'global|99998' },
          { label: 'Todos - exceto estagiários e assistentes', value: 'global|99999' },
        ],
      },
  });

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      const searchFormData = {
        inCharge,
        topic,
        description,
        typeId,
        priorityId,
        scheduleStatusId,
        dateFilterType,
        schedule_date_inicio: initialRegistrationDate,
        schedule_date_final: finalRegistrationDate,
      };

      history.push({
        pathname: '/schedule',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  const asDate = (value: string | Date | Date[] | null) => (
    value instanceof Date ? value : null
  );

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Consultar agendamentos</h3>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuFileText />} title="Assunto">
                  {loggedUserLevel === 'Administrador' ? (
                    <Field id="inChargeDropDown" label="Responsável">
                      <Dropdown
                        id="inChargeDropDown"
                        name="inChargeDropDown"
                        value={inCharge}
                        options={inChargeOptions || {}}
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onChange={(e: {value: any}) => setInCharge(e.value)}
                        optionLabel="label"
                        optionGroupLabel="label"
                        optionGroupChildren="items"
                        filter
                        resetFilterOnHide
                        filterBy="label"
                        appendTo={document.body}
                      />
                    </Field>
                  ) : null}
                  <Field id="topic" label="Assunto">
                    <InputText
                      id="topic"
                      name="topic"
                      value={topic}
                      onChange={(e) => setTopic(e.target.value)}
                    />
                  </Field>
                  <Field id="description" label="Detalhamento">
                    <InputTextarea
                      id="description"
                      name="description"
                      value={description || ''}
                      onChange={(e) => setDescription(e.target.value)}
                      rows={6}
                      cols={30}
                    />
                  </Field>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuListChecks />} title="Atividade">
                  <Field id="schedule_type_id" label="Tipo da atividade">
                    <SelectButton
                      id="schedule_type_id"
                      value={typeId}
                      options={optionsScheduleType}
                      optionLabel="name"
                      optionValue="value"
                      onChange={(e) => setTypeId(e.value)}
                    />
                  </Field>
                  <Field id="schedule_priority_id" label="Prioridade">
                    <SelectButton
                      id="schedule_priority_id"
                      value={priorityId}
                      options={optionsPriority}
                      optionLabel="name"
                      optionValue="value"
                      onChange={(e) => setPriorityId(e.value)}
                    />
                  </Field>
                  <Field id="schedule_status_id" label="Situação da atividade">
                    <SelectButton
                      id="schedule_status_id"
                      className="status-buttons"
                      value={scheduleStatusId}
                      options={optionsScheduleStatus}
                      optionLabel="name"
                      optionValue="value"
                      onChange={(e) => setScheduleStatusId(e.value)}
                    />
                  </Field>
                </Section>

                <Section icon={<LuCalendarRange />} title="Datas">
                  <DateFilter
                    id="schedule_date"
                    label="Data da atividade/reunião"
                    withMode
                    value={{
                      mode: dateFilterType === 'periodo' ? 'periodo' : 'data',
                      start: asDate(initialRegistrationDate),
                      end: asDate(finalRegistrationDate),
                    }}
                    onChange={(next) => {
                      setDateFilterType(next.mode);
                      setInitialRegistrationDate(next.start);
                      setFinalRegistrationDate(next.end);
                    }}
                  />
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => handleClear(handleReset)}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchSchedule;
